import React, { useState, useEffect } from "react";
import {
  Tree,
  Button,
  Typography,
  message,
  Card,
  Spin,
  Row,
  Tag,
  Select,
  Input,
  Col,
} from "antd";
import Get from "../services/Get";
import { useNavigate, useParams } from "react-router-dom";
import { DownOutlined, ReloadOutlined } from "@ant-design/icons";
import { Option } from "antd/lib/mentions";

const MlmTreeView = () => {
  const [treeData, setTreeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedType, setSelectedType] = useState();
  const [selectedRank, setSelectedRank] = useState();
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();
  const { Search } = Input;

  let { userId } = useParams();

  const getRankTag = (rank) => {
    if (rank === "star") return <Tag color="blue">Star</Tag>;
    if (rank === "silver") return <Tag color="green">Silver</Tag>;
    if (rank === "gold") return <Tag color="gold">Gold</Tag>;
    if (rank === "platinum") return <Tag color="grey">Platinum</Tag>;
    if (rank === "diamond") return <Tag color="red">Diamond</Tag>;
  };

  const fetchData = async (id = "", search = "") => {
    setLoading(true);
    try {
      const res = await Get.MLMNetworkTree(id, selectedType, selectedRank, search);
      console.log("res", res);

      if (res.error) {
        message.error(res.error);
      } else {
        const data = formatData(res.data);
        setTreeData(data);
      }
    } catch (error) {
      message.error(error.message);
    }
    setLoading(false);
  };

  const formatData = (data) => {
    return data.map((item) => ({
      title: (
        <>
          {item.user?.name || "Unknown"}{" "}
          {item.plan_type === "paid" ? (
            <Tag color="green">Paid</Tag>
          ) : (
            <Tag color="red">Unpaid</Tag>
          )}{" "}
          {item.rank?.user_rank && getRankTag(item.rank?.user_rank)}(
          {item.reg_no || "N/A"})
        </>
      ),
      key: item.user_id,
      children: [],
      isLeaf: false,
    }));
  };

  const onLoadData = async (treeNode) => {
    console.log(treeData);

    const { key } = treeNode;
    try {
      const response = await Get.MLMNetworkTree(
        key,
        selectedType,
        selectedRank
      );
      if (response.error) {
        message.error(response.error);
      } else {
        const children = formatData(response.data);

        // Update the treeData
        const updatedTreeData = updateTreeData(treeData, key, children);
        setTreeData(updatedTreeData);
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  const updateTreeData = (treeData, key, children) => {
    return treeData.map((node) => {
      if (node.key === key) {
        return { ...node, children, isLeaf: children.length === 0 };
      }
      if (node.children) {
        return {
          ...node,
          children: updateTreeData(node.children, key, children),
        };
      }
      return node;
    });
  };

  const handleSearch = () => {
    fetchData(
      "",
      searchQuery
    );
  };

  useEffect(() => {
    fetchData(userId);
  }, [userId, selectedType, selectedRank]);

  return (
    <>
      <Row
        style={{
          margin: 10,
          paddingRight: 20,
          paddingLeft: 20,
          borderRadius: 12,
          justifyContent: "space-between",
        }}
      >
        {/* <Input.Search
          placeholder="Enter Reg. No"
          allowClear
          onSearch={(value) => {
            if (value) {
              window.location.href = `${window.location.pathname}?user=${value}`;
            }
          }}
          style={{ width: 200, marginLeft: 10 }}
        /> */}

        <Col span={8}>
          <Search
            placeholder={`Search Reg. No`}
            enterButton={<button className="search-button">Search</button>}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onSearch={handleSearch}
            allowClear
          />
        </Col>

        <Col>
          <Select
            placeholder="Select Rank"
            style={{ width: 150, marginRight: "10px" }}
            value={selectedRank}
            onChange={setSelectedRank}
          >
            <Option key={"star"} value={"star"}>
              {getRankTag("star")}
            </Option>
            <Option key={"silver"} value={"silver"}>
              {getRankTag("silver")}
            </Option>
            <Option key={"gold"} value={"gold"}>
              {getRankTag("gold")}
            </Option>
            <Option key={"platinum"} value={"platinum"}>
              {getRankTag("platinum")}
            </Option>
            <Option key={"diamond"} value={"diamond"}>
              {getRankTag("diamond")}
            </Option>
          </Select>

          <Select
            placeholder="Select Plan"
            style={{ width: 150 }}
            value={selectedType}
            onChange={setSelectedType}
          >
            <Option key={"free"} value={"free"}>
              Unpaid
            </Option>
            <Option key={"paid"} value={"paid"}>
              Paid
            </Option>
          </Select>
        </Col>
      </Row>

      <Card
        style={{
          margin: 20,
          padding: 20,
          borderRadius: 12,
        }}
      >
        <Row justify={"space-between"}>
          <Typography.Title level={3}>Affiliate Network Tree</Typography.Title>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            className="form-btn"
            onClick={() => fetchData(userId)}
            style={{ marginBottom: 20 }}
          >
            Refresh Tree
          </Button>
        </Row>
        <Row justify={"center"} align={"middle"} style={{ marginTop: 20 }}>
          {loading ? (
            <Spin size="large" />
          ) : (
            <Tree
              showLine
              switcherIcon={<DownOutlined />}
              loadData={onLoadData}
              treeData={treeData}
              style={{ background: "#fff", padding: 10, borderRadius: 8 }}
            />
          )}
        </Row>
      </Card>
    </>
  );
};

export default MlmTreeView;
